// Prend un objet de clé:valeur et returne un array d'objet {id:clé, value:valeur}
// trié par Id. Il est possible de trié par value si le deuxième paramètre est passé

import {
    CO_W_DEPASSEMENT,
    CO_W_NON_CONFORMITE,
    CO_W_NON_CONFORMITE_AUTRES,
    CO_W_NON_CONFORMITE_INCIDENTS,
    CO_W_NON_CONFORMITE_PRODUIT,
    CO_W_SIGNALEMENT,
    CO_W_URGENCE,
    CO_W_DEROGATION,
    CO_W_RENSEIGNEMENTS,
    CO_W_NON_CONFORMITE_OPPORTUNITE,
    DO_W_FAMILLE_ACTIVITES,
    DO_W_DOSSIER,
    DO_W_DOCUMENT,
    DO_WP_DUPLIQUER,
    DO_WP_CREER_DOC_ELECTRONIQUE,
    DO_W_EXEMPLAIRE_SEC,
    DO_WP_CONFIGURATION_LISTE_CONTROLE,
    DO_WP_EMISSION_DEMANDE_INTEGREE,
    DO_WP_HISTORIQUE_DOSSIER,
    DO_W_CREER_VERSION,
    DO_WP_CHECKIN_AUTO,
    DO_WP_DECLENCHER_WORKFLOW_DOC,
    DO_WP_ANNULER_WORKFLOW,
    DO_W_GESTION_DOCUMENTAIRE,
} from "store/EcranConstants";
import {
    AJOUT,
    DISPONIBLE,
    DOSSIERS_DE_MES_EMPLOYES, ENREG_DE_MES_EMPLOYES, ENREG_SANS_RAPPORTE_PAR,
    LECTURE,
    MODIFICATION,
    SUPPRESSION, TOUS_LES_DOSSIERS, TOUS_LES_ENREG,
    VISIBLE,
} from "../store/DroitConstants"
import { showSnackbarMessage } from "../store/slices/MessagesSystemSlice"

// comme "value".
export function objectToArray(obj, orderByIdOrValue = "id") {
    const newArray = [];
    for (let [key, value] of Object.entries(obj)) {
        newArray.push({ id: key, value: value });
    }

    if (orderByIdOrValue === "value") {
        return newArray.sort((a, b) => a.value.localeCompare(b.value));
    } else {
        return newArray.sort((a, b) => a.id.localeCompare(b.id));
    }
}

// Prend un ensemble d'objets et retourne un nouveau ensemble filtre d'après les paramètres
// filter = key
// filterValue = value
export function filterObject(obj, filter, filterValue) {
    const result = Object.keys(obj).reduce((acc, val) => {
        return obj[val][filter] === filterValue
            ? {
                ...acc,
                [val]: obj[val],
            }
            : acc;
    }, {});
    return result;
}

export const getHeightAndWidthFromDataUrl = (dataURL) =>
    new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
            resolve({
                height: img.height,
                width: img.width,
            });
        };
        img.src = dataURL;
    });

export const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });

export const fileToBinaryString = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsBinaryString(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });


/**
 * Convertit une base64 en blob
 * @param {String} base64Data
 * @returns {Blob}
 */
export const base64ToBlob = (base64Data) => {
    const mimeTypeMatch = base64Data.match(/data:(.*);base64,/)
    const mimeType = mimeTypeMatch ? mimeTypeMatch[1] : 'image/jpeg'
    const _base64Data = base64Data.replace(/^data:image\/\w+;base64,/, '')
    const byteCharacters = Uint8Array.from(atob(_base64Data), c => c.charCodeAt(0))
    const blob = new Blob([byteCharacters], { type: mimeType })
    return blob
}

export const removeObjectProperties = function (obj, props) {
    if (typeof obj === "undefined" || obj === null) return;

    for (let i = 0; i < props.length; i++) {
        if (obj.hasOwnProperty(props[i])) {
            delete obj[props[i]];
        }
    }
};

export const isPropExists = (perso, field) => {
    if (perso === null) return false;

    return perso.persoProprietes.hasOwnProperty(field);
};

export const isPropEquals = (perso, field, value) => {
    if (perso === null) return false;
    return (
        perso.persoProprietes.hasOwnProperty(field) &&
        perso.persoProprietes[field] === value
    );
};

export const propValue = (perso, field, defaultValue) => {
    if (perso === null || perso === undefined) return defaultValue;

    if (!perso.persoProprietes.hasOwnProperty(field)) return defaultValue;

    return perso.persoProprietes[field];
};

export const windowNameByNcType = (ncType) => {
    if (!ncType) return null;

    switch (ncType) {
        case "AUDIT":
        case "INSPECTION":
            return CO_W_NON_CONFORMITE;
        case "PRODUIT":
            return CO_W_NON_CONFORMITE_PRODUIT;
        case "ACCIDENT":
        case "INCIDENT":
            return CO_W_NON_CONFORMITE_INCIDENTS;
        case "URGENCE":
            return CO_W_URGENCE;
        case "SIGNALEMENT":
            return CO_W_SIGNALEMENT;
        case "VALEUR HORS LIMITE":
            return CO_W_DEPASSEMENT;
        case "DÉROGATION":
            return CO_W_DEROGATION;
        case "REQUÊTE":
            return CO_W_RENSEIGNEMENTS;
        case "OPPORTUNITÉ":
            return CO_W_NON_CONFORMITE_OPPORTUNITE;
        default:
            return CO_W_NON_CONFORMITE_AUTRES;
    }
};

export const windowNameByGedPlanSection = section => {
    switch (section) {
        case 'Secteurs': return DO_W_FAMILLE_ACTIVITES
        case 'Dossier': return DO_W_DOSSIER
        case 'Document': return DO_W_DOCUMENT
        case 'Dupliquer': return DO_WP_DUPLIQUER
        case 'Importer': return DO_WP_CREER_DOC_ELECTRONIQUE
        case 'ExemplairesSecondaires': return DO_W_EXEMPLAIRE_SEC
        case 'ListesControle': return DO_WP_CONFIGURATION_LISTE_CONTROLE
        case 'FaireDemande': return DO_WP_EMISSION_DEMANDE_INTEGREE
        case 'Historique': return DO_WP_HISTORIQUE_DOSSIER
        case 'CreerVersion': return DO_W_CREER_VERSION
        case 'Integrer': return DO_WP_CHECKIN_AUTO
        case 'Emettre': return DO_WP_DECLENCHER_WORKFLOW_DOC
        case 'DeclencherWorkflow': return DO_WP_DECLENCHER_WORKFLOW_DOC
        case 'AnnulerWorkflow': return DO_WP_ANNULER_WORKFLOW
        default: return DO_W_GESTION_DOCUMENTAIRE
    }


}
export const sortArray = (data) => {
    if (data) {
        const sorted = data.sort((a, b) => a.value.localeCompare(b.value));
        const active_sorted = sorted.filter((item) => !item.inactive);
        const inactive_sorted = sorted.filter((item) => item.inactive === true);
        return [...active_sorted, ...inactive_sorted];
    }

    return [];
};

// Trie la liste d'objets en fonction du deuxième paramètre passé.
// Params obj = {}, propRefName = ""
export function sortArrObj(obj, propRefName) {
    obj.sort((a, b) => {
        if (a[propRefName] > b[propRefName]) return 1;
        if (a[propRefName] < b[propRefName]) return -1;
        return 0;
    });
    return obj;
}
// Trie la liste d'objets en fonction du deuxième paramètre passé.
// Params obj = {}, propRefName = ""
export function sortLocaleArrObj(obj, propRefName) {
    obj.sort((a, b) => {
        return a[propRefName].localeCompare(b[propRefName]);
    });
    return obj;
}

// Renvoie un nouvel objet sans les propriétés qui contiennent des fausses valeurs.
// Param obj = {}
// Fausses valeurs (falsy) dans le javascript = null, undefined, 0, "", []
export function deleteEmptyValues(obj) {
    let draftObj = obj;

    for (const prop in draftObj) {
        if (!draftObj[prop]) {
            delete draftObj[prop];
        } else if (Array.isArray(draftObj[prop])) {
            if (draftObj[prop].length === 0) {
                delete draftObj[prop];
            }
        }
    }

    return draftObj;
}

// Renvoie un nouvel objet sans les propriétés qui contiennent des valeurs == null.
// Param obj = {}
export function deleteNullValues(obj) {
    let draftObj = obj;

    for (const prop in draftObj) {
        if (draftObj[prop] === null) {
            delete draftObj[prop];
        }
    }

    return draftObj;
}

export function maybePluralize(count, noun, suffix = "s") {
    return `${count} ${noun}${count !== 1 ? suffix : ""}`;
}

/**
 * Vérifie s'il y a eu des changements dans les valeurs des 2 objets passés qui 
 * contiennent les mêmes propriétés, quel que soit l'ordre.
 * @param {Object} obj1 
 * @param {Object} obj2 
 */
export const isEquals = (obj1, obj2) => {
    const keys1 = Object.keys(obj1)
    const keys2 = Object.keys(obj2)
    return JSON.stringify(keys1) === JSON.stringify(keys2)
}

export const getCookieValue = (name) =>
    document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")?.pop() || "";

export const setCookie = (cname, cvalue, exmins) => {
    const d = new Date();
    d.setTime(d.getTime() + exmins * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;secure";
};

export const getHost = (location) => {
    return location.protocol + "//" + location.host;
};

const toString = Object.prototype.toString;
export function deepCopy(obj) {
    let rv;

    switch (typeof obj) {
        case "object":
            if (obj === null) {
                // null => null
                rv = null;
            } else {
                switch (toString.call(obj)) {
                    case "[object Array]":
                        // It's an array, create a new array with
                        // deep copies of the entries
                        rv = obj.map(deepCopy);
                        break;
                    case "[object Date]":
                        // Clone the date
                        rv = new Date(obj);
                        break;
                    case "[object RegExp]":
                        // Clone the RegExp
                        rv = new RegExp(obj);
                        break;
                    // ...probably a few others
                    default:
                        // Some other kind of object, deep-copy its
                        // properties into a new object
                        rv = Object.keys(obj).reduce(function (prev, key) {
                            prev[key] = deepCopy(obj[key]);
                            return prev;
                        }, {});
                        break;
                }
            }
            break;
        default:
            // It's a primitive, copy via assignment
            rv = obj;
            break;
    }
    return rv;
}

export function deepEqual(x, y) {
    const ok = Object.keys, tx = typeof x, ty = typeof y;
    return x && y && tx === 'object' && tx === ty ? (
        ok(x).length === ok(y).length &&
        ok(x).every(key => deepEqual(x[key], y[key]))
    ) : (x === y);
}

const permObject = {
    canAdd: false,
    canEdit: false,
    canRemove: false,
    canRead: false,
    isVisible: false,
    isDisponible: false,
    dossiersDeMesEmployes: false,
    enregDeMesEmployes: false,
    tousLesDossiers: false,
    tousLesEnreg: false,
    enregSansRapportePar: false,
};

/**
 * Compare en profondeur deux valeurs (tableaux ou objets), en ignorant l'ordre des éléments dans les tableaux.
 * Utile pour vérifier si deux tableaux d'objets complexes (avec des listes internes) sont équivalents,
 * même si l'ordre des éléments dans les tableaux internes est différent.
 *
 * @param {any} a - Première valeur à comparer (tableau, objet ou valeur primitive).
 * @param {any} b - Deuxième valeur à comparer.
 * @returns {boolean} Renvoie true si les valeurs sont profondément égales (en ignorant l'ordre des tableaux), false dans le cas contraire.
 */
export function deepEqualUnordered(a, b) {
  if (a === b) return true;
  if (typeof a !== typeof b) return false;

  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false;

    //Si c'est un tableau d'objets ou de tableaux, compare comme des ensembles
    const used = new Array(b.length).fill(false);
    return a.every(itemA => {
      for (let i = 0; i < b.length; i++) {
        if (!used[i] && deepEqualUnordered(itemA, b[i])) {
          used[i] = true;
          return true;
        }
      }
      return false;
    });
  }

  if (typeof a === 'object' && a !== null && b !== null) {
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    return keysA.every(key => deepEqualUnordered(a[key], b[key]));
  }

  return false;
}

export function checkPerms(droitsItem) {
    let droits = { ...permObject };

    for (let ds of droitsItem) {
        droits.canRead = ds.droits.some(d => d.code === LECTURE);
        droits.canEdit = ds.droits.some(d => d.code === MODIFICATION);
        droits.canRemove = ds.droits.some(d => d.code === SUPPRESSION);
        droits.canAdd = ds.droits.some(d => d.code === AJOUT);
        droits.isVisible = ds.droits.some(d => d.code === VISIBLE);
        droits.isDisponible = ds.droits.some(d => d.code === DISPONIBLE);
    }

    return droits;
}

export function formatPerms(_droits) {
    let droits = { ...permObject };

    droits.canRead = _droits.some(d => d.code === LECTURE);
    droits.canEdit = _droits.some(d => d.code === MODIFICATION);
    droits.canRemove = _droits.some(d => d.code === SUPPRESSION);
    droits.canAdd = _droits.some(d => d.code === AJOUT);

    droits.isVisible = _droits.some(d => d.code === VISIBLE);
    droits.isDisponible = _droits.some(d => d.code === DISPONIBLE);

    droits.dossiersDeMesEmployes = _droits.some(d => d.code === DOSSIERS_DE_MES_EMPLOYES);
    droits.enregDeMesEmployes = _droits.some(d => d.code === ENREG_DE_MES_EMPLOYES);

    droits.tousLesDossiers = _droits.some(d => d.code === TOUS_LES_DOSSIERS);
    droits.tousLesEnreg = _droits.some(d => d.code === TOUS_LES_ENREG);

    droits.enregSansRapportePar = _droits.some(d => d.code === ENREG_SANS_RAPPORTE_PAR);

    return droits;
}

export function stopPropagation(callback) {
    return (e) => {
        e.stopPropagation()
        callback(e)
    }
}

export function isObjEmpty(obj) {
    return Object.keys(obj).length === 0;
}

/**
 * Fait défiler une liste d'objets et convertit la valeur des propriétés qui sont nulles
 * en '', à l'exception des propriétés passées en second paramètre
 * @param {Object[]} objList
 * @param {String[]} propsToNotConvert
 * @return {Objet[]} 
 */
export function objListPropsNullToEmptyStr(objList, propsToNotConvert = []) {
    return objList.map(item => objPropsNullToEmptyStr(item, propsToNotConvert));
}

/**
 * Fait convertir la valeur des propriétés de l'objet qui sont nulles en "",
 * à l'exception des propriétés passées dans le second paramètre
 * @param {Object} objList
 * @param {String[]} propsToNotConvert
 * @return {Objet[]} 
 */
export function objPropsNullToEmptyStr(obj, propsToNotConvert = []) {
    return Object.fromEntries(
        Object.entries(obj).map(([prop, value]) => {
            if (!propsToNotConvert.includes(prop)) {
                if (value === null) {
                    return [prop, ''];
                } else if (typeof value === 'object' && !Array.isArray(value)) {
                    return [prop, objPropsNullToEmptyStr(value, propsToNotConvert)];
                } else if (Array.isArray(value)) {
                    return [prop, value.map(element => (typeof element === 'object' ? objPropsNullToEmptyStr(element, propsToNotConvert) : element))];
                }
            }
            return [prop, value];
        })
    );
}

/**
 * Fait convertir la valeur des propriétés de l'objet qui sont nulles en "",
 * uniquement pour les propriétés passées dans le second paramètre
 * @param {Object} obj
 * @param {String[]} propsToConvert
 * @return {Object}
 */
export function objPropsNullToEmptyStrForProps(obj, propsToConvert = []) {
    return Object.fromEntries(
        Object.entries(obj).map(([prop, value]) => {
            if (propsToConvert.includes(prop)) {
                if (value === null) {
                    return [prop, ''];
                } else if (typeof value === 'object' && !Array.isArray(value)) {
                    return [prop, objPropsNullToEmptyStrForProps(value, propsToConvert)];
                } else if (Array.isArray(value)) {
                    return [prop, value.map(element => (typeof element === 'object' ? objPropsNullToEmptyStrForProps(element, propsToConvert) : element))];
                }
            }
            return [prop, value];
        })
    );
}

/**
 * Fait défiler une liste d'objets et convertit la valeur des propriétés qui sont ""
 * en nulles, à l'exception des propriétés passées en second paramètre
 * @param {Object[]} objList
 * @param {String[]} propsToNotConvert
 * @return {Objet[]} 
 */
export function objListPropsEmptyStrToNull(objList, propsToNotConvert = []) {
    return objList.map(item => objPropsEmptyStrToNull(item, propsToNotConvert));
}

/**
 * Fait convertir la valeur des propriétés de l'objet qui sont "" en nulles,
 * à l'exception des propriétés passées dans le second paramètre
 * @param {Object} objList
 * @param {String[]} propsToNotConvert
 * @return {Objet[]} 
 */
export function objPropsEmptyStrToNull(obj, propsToNotConvert = []) {
    if (obj === null || obj === undefined) {
        return obj
    }

    return Object.fromEntries(
        Object.entries(obj).map(([prop, value]) => {
            if (!propsToNotConvert.includes(prop)) {
                if (value === '') {
                    return [prop, null];
                } else if (typeof value === 'object' && !Array.isArray(value)) {
                    return [prop, objPropsEmptyStrToNull(value, propsToNotConvert)];
                } else if (Array.isArray(value)) {
                    return [prop, value.map(element => (typeof element === 'object' ? objPropsEmptyStrToNull(element, propsToNotConvert) : element))];
                }
            }
            return [prop, value];
        })
    );
}

/**
 * Il est important que l'extension du fichier figure à côté du nom.
 * @param {String} fileName
 * @return {String} 
 */
export const getFileTypeByFileName = (fileName) => {
    if (fileName && fileName.includes('.')) {
        const [fileType, _fileName] = fileName.split('.').reverse();
        return `.${fileType?.toLowerCase()}`;
    }
    return null;
};

/**
 * Vérifie que la chaîne contient au moins un caractère avant et après le symbole '@',
 * suivi d'un point et d'autres caractères.
 * @param {String} email
 * @return {Boolean} 
 */
export function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

/**
 * Remplace les caractères %s du texte par les valeurs passées dans l'array replacementStrings
 * @param {String} text
 * @param {String[]} replacementStrings
 * @return {String}
 */
export function iwReplaceString(text, replacementStrings) {
    let index = 0;
    return text.replace(/%s/g, () => replacementStrings[index++]);
}

/**
 * Fonction qui prend un nom de champ windows et le met lower camel case
 * ex. classe_n_c => classeNC
 *     no_bon_travail => noBonTravail
 *     date_1 => date1
 * @param {String} str
 * @return {String}
 */
export function toLowerCamelCase(str) {
    return str.replace(/([-_][a-z0-9])/g, group => group.toUpperCase()
        .replace('-', '')
        .replace('_', ''))
        .replace(/(^[A-Z])/g, group => group.toLowerCase());
}

/**
 * Fonction qui prend un string et le met en Upper Camel Case
 * @param str
 * @returns {*}
 */
export function toUpperCamelCase(str = "") {
    return str.split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join('');
}

/**
 * Fonction qui prend une chaîne de caractères et met la première lettre en majuscule
 * et le reste en minuscule.
 * @example PLANIFIÉ => Planifié
 * @param {string} string 
 * @returns  {string}
 */
export function capitaliseFirstLetter(string) {
    if (!string) return ""
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

/**
 * Un wrapper qui recoit une promesse API (query rtk-query) et qui affiche les messages standard par défaut
 * @param {Dispatch} dispatch - The dispatch function from Redux.
 * @param {Promise} promise - The promise from an rtk-query mutation
 * @param {?object} successMsgOpts - Override d'options pour showSnackbarMessage en cas de succès
 * @param {?object} errorMsgOpts - Override d'options pour showSnackbarMessage en cas d'erreur
 */
export const majWrapper = async (dispatch, promise, successMsgOpts = null, errorMsgOpts = null, displayOnlyError = false, onAfter = () => {}) => {
    try {
        return await promise.unwrap().then((res) => {
            onAfter(res);
            if (displayOnlyError) return res
            dispatch(
                showSnackbarMessage(successMsgOpts ? successMsgOpts : {
                    dba: "objetsLangues2",
                    messageId: "web_confirmation_enregistrement",
                    severity: "success",
                })
            );
            return res
        }).catch((e) => {
            const msg = e?.description || e?.data?.message || e?.data?.messageText || "Erreur inconnue"
            dispatch(showSnackbarMessage(errorMsgOpts ? errorMsgOpts : {
                message: msg,
                severity: "error",
                autoHideDuration: 10000,
            }));
            return false
        });
    } catch (e) {
        const msg = e?.description || e?.data?.message || e?.data?.messageText || "Erreur inconnue"
        dispatch(showSnackbarMessage(errorMsgOpts ? errorMsgOpts : {
            message: msg,
            severity: "error",
            autoHideDuration: 10000,
        }));
        return false
    }
};

export const newWindowHTMLLoader = async (promise) => {
    // Ouverture de l'onglet immédiatement pour ne pas être pris dans l'anti popup
    const newWindow = window.open("", "_blank");
    newWindow.document.write(`
      <html>
        <body>
          <div style="text-align: center; margin-top: 50px;">
            <img src="assets/image/Loading_icon.gif" alt="Loading..." />
          </div>
        </body>
      </html>
    `);
    newWindow.document.close();

    try {
        const response = await promise;

        if (response.isSuccess) {
            newWindow.document.write(response.data);
            newWindow.document.close();
        } else {
            newWindow.close();
        }
    } catch (error) {
        newWindow.close();
    }
}

/**
 * Détecte spécifiquement si l'appareil est un iPad qui se fait passer pour un Mac (iOS 13+)
 * Utile pour ajouter conditionnellement la propriété "capture" aux inputs
 * @returns {boolean} True si l'appareil est un iPad se faisant passer pour un Mac, false sinon
 */
export const isIpadPretendingToBeMac = () => {
  // Vérifier si nous sommes dans un environnement navigateur
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }
  
  // Vérifier la capacité tactile
  const isTouchDevice = (
    'ontouchstart' in window || 
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
  
  // Vérifier si l'user agent contient "Macintosh"
  const isMacLike = /Macintosh/i.test(navigator.userAgent);
  
  // Retourne true uniquement si c'est un appareil qui prétend être un Mac mais qui a des capacités tactiles
  return isMacLike && isTouchDevice;
};

/**
 * Détecte si l'appareil actuel est un appareil mobile (y compris les iPads avec des user agents similaires à Mac)
 * @returns {boolean} True si l'appareil est mobile, false sinon
 */
export const isMobileDevice = () => {
  // Vérifier si nous sommes dans un environnement navigateur
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  // Vérifier d'abord les appareils mobiles évidents via l'user agent
  const mobileRegex = /iPhone|iPad|iPod|Android|webOS|BlackBerry|Windows Phone/i;
  const isMobileByUA = mobileRegex.test(navigator.userAgent);
  
  // Si c'est clairement mobile par l'user agent, retourner true
  if (isMobileByUA) return true;
  
  // Vérifier si c'est un iPad qui se fait passer pour un Mac
  return isMobileByUA || isIpadPretendingToBeMac();
};